import { useCallback, useState } from "react";
import {
  listEventRegistrations,
  type AdminEventRegistration,
} from "../services/eventRegistrationAdminService";

type EventRegistrationsStatus =
  | "pending"
  | "confirmed"
  | "canceled"
  | "waitlist"
  | "all";

type PaymentMethod = "pix" | "credit_card" | "debit_card";

export function useAdminEventRegistrationsState(token?: string | null) {
  const [eventRegistrations, setEventRegistrations] = useState<
    AdminEventRegistration[]
  >([]);
  const [eventRegistrationsLoading, setEventRegistrationsLoading] =
    useState(false);
  const [challengeEventRegistrations, setChallengeEventRegistrations] =
    useState<AdminEventRegistration[]>([]);
  const [
    challengeEventRegistrationsLoading,
    setChallengeEventRegistrationsLoading,
  ] = useState(false);
  const [eventRegistrationsStatus, setEventRegistrationsStatus] =
    useState<EventRegistrationsStatus>("pending");
  const [adminPaymentMethod, setAdminPaymentMethod] =
    useState<PaymentMethod>("pix");

  const loadEventRegistrations = useCallback(async () => {
    if (!token) return;
    setEventRegistrationsLoading(true);
    try {
      const rows = await listEventRegistrations(token, {
        status: eventRegistrationsStatus,
      });
      setEventRegistrations(rows);
    } catch (_err) {
      setEventRegistrations([]);
    } finally {
      setEventRegistrationsLoading(false);
    }
  }, [eventRegistrationsStatus, token]);

  const loadChallengeEventRegistrations = useCallback(
    async (eventId?: string | null) => {
      const safeEventId = String(eventId || "").trim();
      if (!token || !safeEventId) {
        setChallengeEventRegistrations([]);
        return;
      }
      setChallengeEventRegistrationsLoading(true);
      try {
        const rows = await listEventRegistrations(token, {
          status: "all",
          eventId: safeEventId,
        });
        setChallengeEventRegistrations(rows);
      } catch (_err) {
        setChallengeEventRegistrations([]);
      } finally {
        setChallengeEventRegistrationsLoading(false);
      }
    },
    [token],
  );

  return {
    adminPaymentMethod,
    challengeEventRegistrations,
    challengeEventRegistrationsLoading,
    eventRegistrations,
    eventRegistrationsLoading,
    eventRegistrationsStatus,
    loadChallengeEventRegistrations,
    loadEventRegistrations,
    setAdminPaymentMethod,
    setEventRegistrationsStatus,
  };
}
